"use client";

import { CSSProperties } from "react";
import LoadingCpn from "./loadingCpn";
import LogoSVG from "../LogoSVG";

const LoadingPage = ({
  isBlur,
  style,
}: {
  isBlur?: boolean;
  style?: CSSProperties;
}) => {
  return (
    <div
      className="bg-white dark:bg-black"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        position: "relative",
        opacity: isBlur ? 0.9 : 1,
        backdropFilter: isBlur ? "blur(15px)" : "",
        WebkitBackdropFilter: isBlur ? "blur(15px)" : "",
        ...style,
      }}
    >
      <div style={{ display: "flex" }}>
        {/* <Image src={logo} width={110} height={37} alt='Together Work Logo' /> */}
        <LogoSVG />
      </div>
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -10%)",
        }}
      >
        <div>
          <LoadingCpn style={{ width: 100, height: 100 }} />
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
